import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { SplitBanner, SplitBannerImage } from '@lanl-web/lanl-components';
import { slugify } from '../../utils';

import testImage from '../../assets/images/featured-image.png';

import './VisitBanner.scss';

const infoArray = [
  {
    title: 'Hours',
    body: '<p><strong>Monday–Friday</strong><p><p>9:00 a.m. – 4:00 p.m.</p><p class="badge-access"><strong>Badgeholder access 24/7</strong></p>',
  },
  {
    title: 'Location',
    body: '<p>Oppenheimer Study Center<p><p>TA-3, SM-207</p><p>(across from Otowi)</p>',
  },
  {
    title: 'Contact',
    body: '<p>(505) 667-5809<p><p><strong><a href="mailto:library@lanl.gov">library@lanl.gov</a></strong></p>',
  },
];

export const VisitBanner = ({ className }) => {
  const classes = classNames('visit-library-banner', className);

  return (
    <div className={classes}>
      <SplitBanner>
        <div className='lanl-splitbanner-content'>
          <h3 className='lanl-splitbanner-title'>Visit the Library</h3>
          <div className='library-info'>
            {infoArray.map(({ body, title }) => (
              <div
                id={slugify(title)}
                key={`library-info-${slugify(title)}`}
                className='info-box'
              >
                <h4 className='box-title'>{title}</h4>
                <div dangerouslySetInnerHTML={{ __html: body }} />
              </div>
            ))}
          </div>
        </div>
        <SplitBannerImage imgUrl={testImage} />
      </SplitBanner>
    </div>
  );
};

VisitBanner.defaultProps = {};

VisitBanner.propTypes = {
  className: PropTypes.string,
};

export default VisitBanner;
